import StorageManager from "@/features/storage";

export const useParticipantCountry = () => {
  const token = StorageManager.getTokenData();
  return { countryCode: token?.countryCode ?? null };
};
